import { useMemo } from 'react';
import { BaseAsset, FlatAsset } from 'queries/assets/contract';
import { useAssetsByWorkspaceQuery } from 'queries/assets/queries';

export function useAssetList(): FlatAsset[] {
  const { data } = useAssetsByWorkspaceQuery();
  const allItems = data?.items || [];

  const createFlatArray = () => {
    const flatArray: FlatAsset[] = [];

    const createFlatList = (asset: BaseAsset, parent?: BaseAsset) => {
      const flatAsset: FlatAsset = {
        id: asset.id,
        name: asset.name,
        parentId: parent?.id || null,
      };
      flatArray.push(flatAsset);

      if (asset.children) {
        asset.children.forEach((child) => createFlatList(child, asset));
      }
    };

    allItems.forEach((item) => createFlatList(item));

    return flatArray;
  };

  const flatAssetList = useMemo(() => createFlatArray(), [data]);

  return flatAssetList;
}
